/**
 * Unitățile de măsură se scriu la fel peste tot. Stau într-un fișier propriu,
 * nu în ecranul de catalog, fiindcă pagina publică a unei oferte are nevoie de
 * ele fără să tragă după sine tot catalogul.
 */
import { tr } from "./i18n.js";

export const UM = {
  Bucata: "buc", Metru: "m", Set: "set", Ora: "oră", Kilogram: "kg", Litru: "l",
};

/** Traducerea se aplică la citire, ca la `eticheta` — nu la definiția hărții. */
export const um = (v) => tr(UM[v] ?? v);
